import React from 'react';
import PropTypes from 'prop-types';
import {
  IonLabel,
  IonRadioGroup,
  IonRadio,
  IonItem,
  IonList,
  IonIcon,
} from '@ionic/react';
import { checkmarkOutline } from 'ionicons/icons';

function CheckSelect({ checks, selectedId, onSelect }) {
  return (
    <IonList className="ion-padding">
      <IonRadioGroup
        value={selectedId}
        onIonChange={(e) => onSelect(e.detail.value)}
      >
        {checks &&
          checks.map((c, index) => (
            <IonItem
              key={c._id}
              lines="full"
              className="py-20"
              // disabled={c.userIds && c.userIds.length > 0}
            >
              {c.users && c.users.length > 0 ? (
                <IonIcon
                  className="check-menu-item-icon"
                  icon={checkmarkOutline}
                  color="success"
                  slot="start"
                />
              ) : (
                <IonRadio
                  color="tertiary"
                  slot="start"
                  mode="android"
                  value={c._id}
                />
              )}
              <IonLabel color={c._id === selectedId ? 'primary' : 'medium'}>
                <p>
                  <b>SEAT {index + 1}</b>
                </p>
                {c.items &&
                  c.items.map((item) => (
                    <p key={item.extId}>
                      {Math.round(item.quantity * 100)}&nbsp;&nbsp;
                      {item.name}
                    </p>
                  ))}
              </IonLabel>
            </IonItem>
          ))}
      </IonRadioGroup>
    </IonList>
  );
}

CheckSelect.propTypes = {
  checks: PropTypes.array,
  onSelect: PropTypes.func,
  selectedId: PropTypes.string,
};

export default CheckSelect;
